import { defineComponent as _defineComponent } from 'vue'
import { setBlockTracking as _setBlockTracking, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fbaa47e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "year" }
const _hoisted_2 = { class: "authors-section" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "authors-section__heading" }, "Website created by:", -1 /* HOISTED */))

import GithubLink from './GithubLink.vue';

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {


const year = ref((new Date()).getFullYear());


return (_ctx: any,_cache: any) => {
  return _cache[0] || (
    _setBlockTracking(-1),
    _cache[0] = _createElementVNode("footer", { class: "page-footer" }, [
      _createElementVNode("span", _hoisted_1, " @" + _toDisplayString(year.value) + ". All rights reserved ", 1 /* TEXT */),
      _createElementVNode("address", _hoisted_2, [
        _hoisted_3,
        _createVNode(GithubLink, { name: "RichGihratik" }),
        _createVNode(GithubLink, { name: "Pa4ka1992" })
      ])
    ]),
    _setBlockTracking(1),
    _cache[0]
  )
}
}

})